import { ReactNode } from 'react';
import { Navbar } from './Navbar';
import DebugPanel from '../debug/DebugPanel';
import { isDevelopment } from '../../utils';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      <footer className="bg-white border-t mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-sm text-tedy-gray">
            © {new Date().getFullYear()} TalentED YYC. Powered by <a href="https://iaxov.com" target="_blank">IAXOV</a>.
          </p>
          {isDevelopment() && (
            <p className="text-center text-xs text-tedy-gray mt-1">
              Development Mode
            </p>
          )}
        </div>
      </footer>
      {isDevelopment() && <DebugPanel />}
    </div>
  );
};
